/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import colors from 'styles/colors';

export const NotificationLink = styled.span`
  color: ${colors.azure};
  cursor: pointer;
`;
